var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { style: _vm.containerStyle }, [
    _c(
      "div",
      { staticClass: "btn", style: _vm.style },
      [
        _c("html-editor", {
          ref: "editor",
          attrs: {
            "toolbar-module": _vm.toolbarModule,
            "toolbar-defaults": _vm.toolbarDefaults,
            theme: _vm.editorTheme,
            value: _vm.initialText
          },
          on: {
            input: function($event) {
              return _vm.$emit("text-changed", $event)
            },
            blur: function($event) {
              _vm.hasFocus = false
            },
            focus: function($event) {
              _vm.hasFocus = true
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }